import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Page from "../pc-page";
import { connect } from 'react-redux';
import NoPermission from './no-permission' //缺省页
import { getUserInfo } from "@/actions/userInfo";
import { getPermissionList } from "@/actions/permission";
import { getEdit } from "@/actions/editGuidance";
import { getMessageSettingsOpen, getThirdChatAuth, getComAuthInfo, getMessageOpenParams, getCompanyNoExpire, getAgentConfig } from "@/actions/messageSettingsOpen";
import { getCrmPermission } from "@/actions/crmPermission";
import { setGlobalConfig } from '@/actions/globalConfig'
import api from '@/apis/common/common'
import guidanceApi from '@/apis/pc/guidance/guidance';
import { message } from 'antd';
import { isQD } from '../../utils/common';
import { getThirdWxConfig } from "@/utils/utils";

const shouldCheckThirdPaths = [
  '/conversation', // 会话存档
  '/conversation-friend', // crm新好友中的会话存档
  '/warnings', // 违规提醒
  '/warning-detail', // 违规提醒
  '/message-reply-list', // 超时未回复提醒
  '/standard-operating', // SOP
  '/markets', // 群活码
  '/qw-assistant', // 设置-企微助手-会话存档设置页
  '/sidebar', // 侧边栏
]


const mapStateToProps = (state) => {
  const { userInfo, enterPriseInfo, messageSettingsOpen: {messageSettingsOpen, thirdChatAuth, comAuthInfo, messageOpenParams, companyNoExpire} } = state;
  return { ...enterPriseInfo, ...userInfo, thirdChatAuth, comAuthInfo, messageOpenParams, companyNoExpire, messageSettingsOpen };
}
const mapDispatchToProps = {
  getUserInfo,
  getEdit,
  getPermissionList,
  getMessageSettingsOpen,
  getThirdChatAuth,
  getComAuthInfo,
  getCompanyNoExpire,
  getCrmPermission,
  setGlobalConfig,
  getMessageOpenParams,
  getAgentConfig,
};
function Home(props) {
  const isQiDian = isQD();
  // 企业配置的信息
  let history = useHistory()
  const locationRef = useLocation()
  let { pathname, search } = useLocation()
  const thirdSetting = pathname.indexOf('/qw-assistant') >= 0 || pathname.indexOf('/enterprise-wechat-assistant') >= 0;
  if (thirdSetting) {
    pathname = pathname + search
  }
  const [showPage, setShowPage] = useState(isQiDian ? 2: 0);
  const [thirdsignature, setThirdsignature] = useState(false); // 三方签名
  const timer = useRef(); // 定时器
  useEffect(() => {
    props.getEdit();
    props.getMessageOpenParams();
    props.getUserInfo();
    props.getPermissionList();
    props.getMessageSettingsOpen();
    props.getThirdChatAuth();
    props.getComAuthInfo();
    props.getCompanyNoExpire();
    props.getCrmPermission();
  }, [])

  const checkThirdError = (res) => {
    message.error(res?.message)
    setShowPage(2)
    history.go(-1)
  }

  // scrm专业版上 第三方应用进入以下页面需要跳转到/third-guide
  const checkThird = (pathname) => {
    const url = window.location.hash.substr(1);
    if (window?.crm_platform_type !== 'wxwork') {
      checkFn()
      return
    }
    if (shouldCheckThirdPaths.includes(pathname)) {
      setShowPage(0)
      api.checkApply().then(res => {
        if (res?.code === 0) {
          // 为保证最新 每次进入提前获取标识
          // true 试用版 变成自建应用就是false
          if (res?.data?.isTrial && props.companyNoExpire.apiStatus) {
            if (props.companyNoExpire?.onLyThird) {
              // setShowPage(2)
              // console.log('sign', 1)
              // history.push({ pathname: '/guidance', state: { url: `${url || '/enterprise-customer'}` }, search: 'isThird=1' })
              checkFn()
            } else {
              setShowPage(2)
              history.push(`/third-guide?from=${pathname}`);
            }
            
            // 下面是新的逻辑
            // history.push(`/open-information?from=${pathname}`);
          }
          else {
            checkFn()
            setShowPage(2)
          }
          return
        }
        checkThirdError(res)
      }).catch(err => {
        checkThirdError(err)
      })
    }
    else {
      checkFn()
    }
  };

  // 三方页面判断
  const checkThirdPage = () => {
    const url = window.location.hash.substr(1);
    const urlHash = window?.location?.hash;
    const urlNoSearch = urlHash .split('?')[0];
    const jumpFn = (isThird) => {
      //企业未添加过配置，则跳转配置页，设置完成返回传入页面
      if (location.hash.includes('#/third-guide')) {
        setShowPage(2)
        return
      }
      const pushurl = '/guidance';
      if (isThird) {
        // history.push({ pathname: pushurl, state: { url: `${url || '/enterprise-customer'}` }, search: 'isThird=1' })
        history.push({ pathname: '/open-information', state: { url: `${url || '/enterprise-customer'}` }, search: 'isThird=1' })
        return
      }
    };
    // if (!props.companyNoExpire?.isThrid && props.messageSettingsOpen.open) return;
    // 只开通了三方会话
    if (props.thirdChatAuth?.auth) {
      if (window?.crm_platform_type === 'wxwork') {
        setShowPage(2)
      } else {
        jumpFn(1)
      }
      return
    } else if (!props.thirdChatAuth?.auth) {
      if (['#/guidance'].indexOf(urlNoSearch) > -1) {
        setShowPage(2)
        return
      }
      // if (props.companyNoExpire?.onLyThird) {
      //   history.push({ pathname: '/guidance', state: { url: `${url || '/enterprise-customer'}` }, search: 'isThird=1' })
      //   return
      // }
      history.push({ pathname: '/open-information', state: { url: `${url || '/enterprise-customer'}` }, search: 'isThird=1' })
      setShowPage(2)
      return
    }
  }

  const checkFn = async () => {
    const url = window.location.hash.substr(1);
    const urlHash = window?.location?.hash;
    const urlNoSearch = urlHash .split('?')[0];
    const thirdUrl = ['#/warnings', '#/warning-detail', '#/message-reply-list', '#/conversation', '#/guidance']
    const thirdSetting = urlHash.indexOf('#/qw-assistant?tab=2') >= 0 || urlHash.indexOf('#/enterprise-wechat-assistant?tab=2') >= 0;
    if (
      ([...thirdUrl, ...['#/open-information']].indexOf(urlNoSearch) > -1 || thirdSetting || urlNoSearch.indexOf('#/group-detail/') >= 0 || urlNoSearch.indexOf('#/conversation-friend') >= 0) &&
      (props.companyNoExpire?.isThrid || !props.messageSettingsOpen.open || props.companyNoExpire?.lastChatVersion == 2) &&
      props.companyNoExpire?.thirdAgentId &&
      props.companyNoExpire?.corpId  &&
      props.thirdChatAuth?.auth &&
      !thirdsignature
    ) {
      if ((props.companyNoExpire?.onLyThird || (props.companyNoExpire?.isThrid && props.thirdChatAuth?.auth && !props.companyNoExpire.isBind) || props.companyNoExpire?.lastChatVersion == 2 || (!props.messageSettingsOpen.open && props.thirdChatAuth?.auth))) {
        const r = await getThirdWxConfig({
          corpId: props.companyNoExpire?.openCorpId ||  props.companyNoExpire?.corpId,
          thirdAgentId: props.companyNoExpire?.thirdAgentId,
        })
        if (r === 'success') {
          setThirdsignature(true);
          props.getAgentConfig(() => {
            return Promise.resolve({
              success: true,
              data: {
                thirdsignature: true,
              },
            });
          });
        }
      } 
    }
    if (props.thirdChatAuth?.apiStatus && props.comAuthInfo?.apiStatus && props.messageOpenParams?.apiStatus && ([...thirdUrl, ...['#/open-information']].indexOf(urlNoSearch) > -1 || thirdSetting) &&
      (
        props.companyNoExpire?.onLyThird ||
        (props.enterPriseInfo.isBind && props.companyNoExpire?.lastChatVersion == null && props.companyNoExpire?.isThrid) ||
        !props.messageSettingsOpen.open ||
        props.companyNoExpire?.lastChatVersion == 2
      )
    ) {
      checkThirdPage();
      return
    }
    //apiStatus接口请求完成，字段为true
    if (props.enterPriseInfo.apiStatus && props.userInfo.apiStatus && props.thirdChatAuth?.apiStatus && props.comAuthInfo?.apiStatus && props.messageOpenParams?.apiStatus) {
      //企业配置的信息 企微客户秘钥
      if (props.enterPriseInfo.corpId && props.enterPriseInfo.enable) {
        // 
        if (['#/standard-operating', '#/markets', '#/sidebar', '#/conversation', '#/warnings', '#/warning-detail', '#/message-reply-list','#/open-information', '#/qw-assistant'].indexOf(urlNoSearch) > -1 && !props.enterPriseInfo.isBind) {
          //会话存档，群活码，侧边栏  sop 违规提醒 超时未回复这些页面增加判断  判断isBind  false跳转配置引导页
          const jumpFn = () => {
            //企业未添加过配置，则跳转配置页，设置完成返回传入页面
            if (location.hash.includes('/third-guide')) {
              setShowPage(2)
              return
            }
            history.push({ pathname: '/guidance', state: { url: `${url || '/enterprise-customer'}` } })
            setShowPage(2)
          }
          if (window?.crm_platform_type === 'wxwork') {
            // 第三方应用不受一下逻辑的影响 自建应用false
            api.checkApply().then(res => {
              const isTrial = res?.data?.isTrial
              if (isTrial) {
                // if(!props.thirdChatAuth?.auth  && props.companyNoExpire?.isThrid && ['#/conversation'].indexOf(urlNoSearch) > -1) {
                //   checkThirdPage();
                // } else {
                //   setShowPage(2)
                // }
                setShowPage(2)
              }
              else {
                jumpFn()
              }
            })
            // if(!props.thirdChatAuth?.auth  && props.companyNoExpire?.isThrid && ['#/conversation'].indexOf(urlNoSearch) > -1) {
            //   checkThirdPage();
            // } else {
            //   setShowPage(2)
            // }
            setShowPage(2)
            return
          }
          else {
            jumpFn()
          }
          //企业未添加过配置，则跳转配置页，设置完成返回传入页面
          if (location.hash.includes('/third-guide')) {
            setShowPage(2)
            return
          }
          history.push({ pathname: '/guidance', state: { url: `${url || '/enterprise-customer'}` } })
          setShowPage(2)
        } else {
          if (!props.userInfo.wxUserId) {
            //部门员工未设置，显示绑定页面
            setShowPage(1)
          } else {
            // if(!props.thirdChatAuth?.auth  && props.companyNoExpire?.isThrid && ['#/conversation'].indexOf(urlNoSearch) > -1) {
            //   checkThirdPage();
            // } else {
            //   setShowPage(2)
            // }
            setShowPage(2)
          }
        }
      } else {
        const jumpFn = () => {
          //企业未添加过配置，则跳转配置页，设置完成返回传入页面
          if (location.hash.includes('/third-guide')) {
            setShowPage(2)
            return
          }
          history.push({ pathname: '/guidance', state: { url: `${url || '/enterprise-customer'}` } })
          setShowPage(2)
        }
        if (window?.crm_platform_type === 'wxwork') {
          // 第三方应用不受一下逻辑的影响 自建应用false
          api.checkApply().then(res => {
            const isTrial = res?.data?.isTrial
            if (isTrial) {
              // if(!props.thirdChatAuth?.auth  && props.companyNoExpire?.isThrid && ['#/conversation'].indexOf(urlNoSearch) > -1) {
              //   checkThirdPage();
              // } else {
              //   setShowPage(2)
              // }
              setShowPage(2)
            }
            else {
              jumpFn()
            }
          })
          // if(!props.thirdChatAuth?.auth  && props.companyNoExpire?.isThrid && ['#/conversation'].indexOf(urlNoSearch) > -1) {
          //   checkThirdPage();
          // } else {
          //   setShowPage(2)
          // }
          setShowPage(2)
          return
        }
        else {
          jumpFn()
        }
        //企业未添加过配置，则跳转配置页，设置完成返回传入页面
        if (location.hash.includes('/third-guide')) {
          setShowPage(2)
          return
        }
        history.push({ pathname: '/guidance', state: { url: `${url || '/enterprise-customer'}` } })
        setShowPage(2)
      }
    }
  }

  // 清除定时器
  const clearTimer = () => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
  }

  // 设置定时器函数
  const setTimerFn = (cb) => {
    clearTimer();
    timer.current = setTimeout(() => {
      cb && cb();
      timer.current = null;
    }, 300)
  }

  useEffect(() => {
    if(!isQiDian) {
      setTimerFn(checkFn);
      
    }
  }, [props.enterPriseInfo, props.userInfo, props.thirdChatAuth, props.comAuthInfo, props.messageOpenParams, props.companyNoExpire, thirdsignature, props.messageSettingsOpen])

  useEffect(() => {
    if(!isQiDian && props.companyNoExpire.apiStatus) { 
      // 跳到会话存档 希望 第三方依旧校验第三方 不是第三方走http://zentao.weiwenjia.com/bug-view-56158.html的修改 跳扫码页
      const condition = location.href.includes('/conversation') || location.href.includes('/conversation-friend')
      if (condition || pathname === '/') {
        const isQwQThird = condition && crm_platform_type === 'wxwork'
        isQwQThird && checkThird(pathname)
        !isQwQThird && setTimerFn(checkFn);
      }
      // 老的逻辑pathname变更没有任何check
      else {
        checkThird(pathname)
      }
    }
  }, [pathname, props.companyNoExpire])
  return [<div key={"empty"} />, <NoPermission key={"permission"} />, <Page key={"page"} {...props} />][showPage]
}
export default connect(mapStateToProps, mapDispatchToProps)(Home);
